(function ($) {
  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for desktop
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(min-width: 768px)", function () {});

  ////////////////////////////////////////////////////////////////////////////////////
  // Set enquire for mobile
  ////////////////////////////////////////////////////////////////////////////////////
  enquire.register("(max-width: 767px)", function () {});

  var lenis;

  ////////////////////////////////////////////////////////////////////////////////////
  // Common JS - All Pages
  ////////////////////////////////////////////////////////////////////////////////////
  var Sage = {
    common: {
      init: function () {

        ////////////////////////////////////////////////////////////////////////////////////
        // AOS - Animate on scroll init
        ////////////////////////////////////////////////////////////////////////////////////
        AOS.init({
          delay: 100, // values from 0 to 3000, with step 50ms
          initClassName: 'aos-init', // class applied after initialization
          animatedClassName: 'aos-animate', // class applied on animation
          duration: 400, // values from 0 to 3000, with step 50ms
          easing: 'ease', // default easing for AOS animations
          once: true, // whether animation should happen only once - while scrolling down
          anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Search Functionality
        ////////////////////////////////////////////////////////////////////////////////////
        $(document).on('click', '.js-init-sitewide-search', function () {

          ////////////////////////////////////////////////////////////////////////////////////
          // Show Search
          ////////////////////////////////////////////////////////////////////////////////////
          if ($('.js-section-site-search').is(':hidden')) {
            $('.js-section-site-search').slideDown('slow', function () {
              $('#header-search').val('').focus();
            });
          } else {
            $('.js-section-site-search').slideUp('slow');
          }

          ////////////////////////////////////////////////////////////////////////////////////
          // Return False
          ////////////////////////////////////////////////////////////////////////////////////
          return false;

        });

        //////////////////////////////////////////////////////////////
        // Animate Hamburger
        //////////////////////////////////////////////////////////////
        $('.navbar-toggler').on('click', function () {
          $(this).toggleClass('active');
          $('.navbar').toggleClass('active');
          $('body').toggleClass('navbar-active');
        });

        
        jQuery('.js-toggle-menu').on('click', function() {
          var $menu = $('.bry-side-menu');
          var $innermenu = $('.js-bry-side-menu-container-menu').find('.bry-side-menu-button .navbar-nav');
          var $body = $('body');

          if ($menu.hasClass('active')) {
            $body.removeClass('menu-active');
            $innermenu.css('z-index', 1);
            setTimeout(function() { $menu.removeClass('active'); }, 400);
          } else {
            $menu.addClass('active');
            setTimeout(function() { $innermenu.css('z-index', 1025); }, 400);
            $body.addClass('menu-active');
          }
        });
        

        
        //////////////////////////////////////////////////////////////
        // Menu Hover Dropdown (Bootstrap Controlled)
        //////////////////////////////////////////////////////////////
        $('.js-navbar-nav li.dropdown').hover(
          function () {
            if ($(window).width() > 1199) {
              const toggleEl = $(this).find('[data-bs-toggle="dropdown"]')[0];
              const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggleEl);
              dropdown.show();
            }
          },
          function () {
            if ($(window).width() > 1199) {
              const toggleEl = $(this).find('[data-bs-toggle="dropdown"]')[0];
              const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggleEl);
              dropdown.hide();
            }
          }
        );


        //////////////////////////////////////////////////////////////
        // Calculate True VH
        //////////////////////////////////////////////////////////////
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Contact Form Validation
        ////////////////////////////////////////////////////////////////////////////////////
        $('#js-form-contact').validate({
          rules: {
            email: {
              remote: {
                url: '/wp-admin/admin-ajax.php',
                type: "POST",
                data: {
                  'action': 'valid_email_lookup',
                  'email_value': function () {
                    return $("#email").val();
                  },
                },
              },
            },
            phone_number: {
              validPhone: true,
            },
            'checkbox_multiple': {
              required: true,
            },
            'radio_multiple': {
              required: true,
            }
          },
          highlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-invalid').removeClass('is-valid');
            $(element).parents().children('.invalid-feedback').css('display', 'block');
            $(element).parents().children('.valid-feedback').css('display', 'none');
          },
          unhighlight: function (element) {
            $(element).parents('.form-group').find('input, select, textarea').addClass('is-valid').removeClass('is-invalid');
            $(element).parents().children('.invalid-feedback').css('display', 'none');
            $(element).parents().children('.valid-feedback').css('display', 'block');
          },
          errorPlacement: function () {
            $(this).parents('form').addClass('was-validated');
            return false;
          },
          submitHandler: function (form) {

            ////////////////////////////////////////////////////////////////////////////////////
            // Display ajax loader
            ////////////////////////////////////////////////////////////////////////////////////
            $('.js-contact-error, .js-contact-recaptcha-error, #js-form-contact').css('display', 'none');
            $('.js-contact-loader').css('display', 'block');

            ////////////////////////////////////////////////////////////////////////////////////
            // Validate reCaptcha
            ////////////////////////////////////////////////////////////////////////////////////
            generate_google_recaptcha_token('contact_form').then(function (response) {

              ////////////////////////////////////////////////////////////////////////////////////
              // reCaptcha Response
              ////////////////////////////////////////////////////////////////////////////////////
              var reCaptchaResponse = jQuery.parseJSON(response);

              ////////////////////////////////////////////////////////////////////////////////////
              // IF Invalid - Show Error
              ////////////////////////////////////////////////////////////////////////////////////
              if (reCaptchaResponse.valid == 'false') {

                ////////////////////////////////////////////////////////////////////////////////////
                // Display Error
                ////////////////////////////////////////////////////////////////////////////////////
                $('.js-contact-loader').css('display', 'none');
                $('#js-form-contact, .js-contact-recaptcha-error').css('display', 'block');

                ////////////////////////////////////////////////////////////////////////////////////
                // ELSE Success
                ////////////////////////////////////////////////////////////////////////////////////
              } else {

                ////////////////////////////////////////////////////////////////////////////////////
                // Ajax Variables
                ////////////////////////////////////////////////////////////////////////////////////
                var apiRequestError = false; // API Request Error Status

                ////////////////////////////////////////////////////////////////////////////////////
                // Mandrill Payload
                ////////////////////////////////////////////////////////////////////////////////////
                var mandrillPayload = mandrill_json_payload('#js-form-contact'); // Mandrill API Payload

                console.log(mandrillPayload);
                return false;

                ////////////////////////////////////////////////////////////////////////////////////
                // Campaign Monitor Subscriber Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var cmPayload = new Object();
                // cmPayload.customFields = {}
                // cmPayload.listID = 'a480aacea0c318f253bf9feff5d97c83';
                // cmPayload.name = $('#first_name').val() + ' ' + $('#last_name').val();
                // cmPayload.emailAddress = $('#email').val();

                // cmPayload.customFields.PhoneNumber = $('#phone_number').val();
                // cmPayload.customFields.Message = $('#message').val();
                // cmPayload.customFields.RadioOptions = $('input[name=radioexample]:checked').val();
                // cmPayload.customFields.SelectOption = $('#select_example').val();

                // cmPayload.customFields.CheckboxField = [];
                // $('[name="checkboxexample"]').each(function( index ) {
                //   if($(this).is(':checked')) {
                //     cmPayload.customFields.CheckboxField.push($(this).val());
                //   }
                // });

                ////////////////////////////////////////////////////////////////////////////////////
                // MailChimp Payload
                ////////////////////////////////////////////////////////////////////////////////////
                // var mailChimpPayload = new Object();
                // mailChimpPayload.customFields = {}
                // mailChimpPayload.listID = 'f0dddbd24e';
                // mailChimpPayload.emailAddress = $('#email').val();

                // ////////////////////////////////////////////////////////////////////////////////////
                // // MailChimp custom fields
                // ////////////////////////////////////////////////////////////////////////////////////
                // mailChimpPayload.customFields.FNAME = $('#first_name').val();
                // mailChimpPayload.customFields.LNAME = $('#last_name').val();
                // mailChimpPayload.customFields.MERGE3 = $('#phone_number').val();

                ////////////////////////////////////////////////////////////////////////////////////
                // Load call to API
                ////////////////////////////////////////////////////////////////////////////////////
                $.when(

                  //////////////////////////////////////////////////////////////////////////////////
                  // Mandrill Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  $.ajax({
                    type: "POST",
                    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mandrill/notification',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: mandrillPayload,
                    success: function (data) {

                      ////////////////////////////////////////////////////////////////////////////////////
                      // If there is an error with the Mandrill Call, display in console.
                      ////////////////////////////////////////////////////////////////////////////////////
                      if (data.status == 'error') {

                        ////////////////////////////////////////////////////////////////////////////////////
                        // Log Error
                        ////////////////////////////////////////////////////////////////////////////////////
                        console.log(data);
                        apiRequestError = true;

                      }

                    },
                  })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Campaign Monitor Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/cm/subscriber/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(cmPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // MailChimp Payload Call
                  //////////////////////////////////////////////////////////////////////////////////
                  // $.ajax({
                  //    type: "POST",
                  //    url: 'https://api.' + nous_api_data.api_endpoint + '.com.au/mailchimp/member/add',
                  //    dataType: 'json',
                  //    contentType: 'application/json',
                  //    data: JSON.stringify(mailChimpPayload),
                  //    success:function(data) {

                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       // If there is an error with the Mandrill Call, display in console.
                  //       //////////////////////////////////////////////////////////////////////////////////
                  //       if(data.status == 'error') {

                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         // Log Error
                  //         ////////////////////////////////////////////////////////////////////////////////////
                  //         console.log(data);
                  //         apiRequestError = true;

                  //       }

                  //    },
                  // })

                  //////////////////////////////////////////////////////////////////////////////////
                  // Once all api calls are complete
                  //////////////////////////////////////////////////////////////////////////////////
                ).then(function () {

                  ////////////////////////////////////////////////////////////////////////////////////
                  // Display Success / Error based on returned API
                  ////////////////////////////////////////////////////////////////////////////////////
                  if (apiRequestError == false) {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Success Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('.js-contact-success').css('display', 'block');

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Data Layer
                    ////////////////////////////////////////////////////////////////////////////////////
                    dataLayer.push({
                      'event': 'gaTriggerEvent',
                      'gaEventCategory': 'Form',
                      'gaEventAction': 'Enquiry',
                      'gaEventLabel': 'Success'
                    });

                  } else {

                    ////////////////////////////////////////////////////////////////////////////////////
                    // Error Block
                    ////////////////////////////////////////////////////////////////////////////////////
                    $('.js-contact-loader').css('display', 'none');
                    $('#js-form-contact').css('display', 'block');
                    $('.js-contact-error').css('display', 'block');

                  }


                });


              }
            });

          } // END ELSE VALID RECAPTCHA
        }); // END GENERATE GOOGLE reCAptcha Token

        ////////////////////////////////////////////////////////////////////////////////////
        // Chosen Init
        ////////////////////////////////////////////////////////////////////////////////////
        $('body').find('select').each(function() {
          $(this).chosen();
        });
      }
    },

    ////////////////////////////////////////////////////////////////////////////////////
    // Home page
    ////////////////////////////////////////////////////////////////////////////////////
    home: {
      init: function () {}
    },
  };

  window.addEventListener('load', function () {
    AOS.refreshHard();
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  ////////////////////////////////////////////////////////////////////////////////////
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.




jQuery(document).ready(function ($) {

  $('.flexi-team-cards').each(function(index) {

    const $teamCards = $(this);
    const $images = $teamCards.find('.team-image');
    const $wrapper = $teamCards.find('.team-image-wrapper');
    const $accordion = $teamCards.find('.accordion');

    // 👇 Give each accordion a unique ID
    const accordionId = 'accordion-' + index;
    $accordion.attr('id', accordionId);

    // 👇 Set correct data-bs-parent only inside this block
    $accordion.find('.accordion-collapse').each(function() {
      $(this).attr('data-bs-parent', '#' + accordionId);
    });

    // Show first image initially
    $images.hide().first().addClass('active').show();

    function setWrapperHeight() {
      const contentHeight = $wrapper.find('.team-image.active').outerHeight() || 0;
      $wrapper.height(contentHeight);
    }

    $accordion.on('show.bs.collapse', '.accordion-collapse', function () {

      const $item = $(this).closest('.accordion-item');
      const index = $item.index();

      $images.stop(true, true).removeClass('active').hide();
      $images.eq(index).stop(true, true).addClass('active').show();

      setTimeout(setWrapperHeight, 350);
    });

    setWrapperHeight();
    $(window).on('resize', setWrapperHeight);
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // STATISTICS CARDS
  ////////////////////////////////////////////////////////////////////////////////////
  /* PARRALLAX VERSION */
  jQuery(function ($) {
    if($('.js-flexi-statistics-background-remove img').length > 0){
      const $bg = $('.js-flexi-statistics-background-remove img');  
      const speed = 0.4; // adjust for more or less movement
      $(window).on('scroll', function () {
        const scrollTop = $(window).scrollTop();
        const winHeight = $(window).height();
        const $section = $('.section-flexi-statistics-block');
        const sectionTop = $section.offset().top;
        const sectionHeight = $section.outerHeight();
        // Check if section is visible in viewport
        if (scrollTop + winHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {
          const relativeScroll = scrollTop - sectionTop;
          const translateY = relativeScroll * speed;
          $bg.css('transform', `translateY(${translateY}px)`);
        }
      });
    }
  });


  ////////////////////////////////////////////////////////////////////////////////////
  // GFORM TEXTAREA
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery(function($){
    var SELECTOR = '.gform_wrapper textarea.small';
    var BASE = 39.5;
    var MAX = 96;

    function initTextarea($el){
      $el[0].style.setProperty('height', BASE + 'px', 'important');
      $el[0].style.setProperty('overflow', 'hidden', 'important');
      $el[0].style.setProperty('resize', 'none', 'important');
      $el[0].style.setProperty('max-height', MAX + 'px', 'important');

      function resize(){
        $el[0].style.setProperty('height', BASE + 'px', 'important');
        var newH = Math.min(Math.max($el[0].scrollHeight, BASE), MAX);
        $el[0].style.setProperty('height', newH + 'px', 'important');
  
        if ($el[0].scrollHeight > MAX) {
          $el[0].style.setProperty('overflow-y', 'auto', 'important');
        } else {
          $el[0].style.setProperty('overflow-y', 'hidden', 'important');
        }
      }

      $el.on('input change paste', function(event){
        if (event.type === 'paste') setTimeout(resize, 10);
        else resize();
      });

      resize();
    }

    $(document).on('gform_post_render', function(){
      $(SELECTOR).each(function(){ initTextarea($(this)); });
    });

    $(SELECTOR).each(function(){ initTextarea($(this)); });
  });


  ////////////////////////////////////////////////////////////////
  // GALLERY CAROUSEL BLOCK - init flickity slider
  ////////////////////////////////////////////////////////////////

  $('.js-flickity-gallery-slider').each(function () {
    const $slider = $(this);

    // Initialize Flickity
    const flkty = new Flickity(this, {
      cellSelector: '.flexi-gallery-slider-cell',
      cellAlign: 'left',
      contain: false,
      groupCells: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: true
    });
    
  });
  

  ////////////////////////////////////////////////////////////////
  // Gallery Slider
  ////////////////////////////////////////////////////////////////
  $('.section-flexi-gallery-carousel').each(function(){

    const $section = $(this);

    $section.find('.custom-carousel-wrapper').each(function(){

      const $wrapper = $(this);
      const $viewport = $wrapper.find('.custom-carousel-viewport');
      const $carousel = $wrapper.find('.custom-carousel');
      const $cells = $carousel.children('.carousel-cell');
      const $prevBtn = $wrapper.find('.carousel-prev');
      const $nextBtn = $wrapper.find('.carousel-next');
      const $captionOutput = $wrapper.find('#active-caption');

      let cellWidth = $cells.outerWidth(true);
      const totalCells = $cells.length;

      $carousel.prepend($cells.clone());
      $carousel.append($cells.clone());

      let currentIndex = totalCells;
      let isAnimating = false;
      let animFrame = null;
      let isDragging = false;
      let startX = 0, dragDelta = 0, velocity = 0, lastX = 0, lastTime = 0;

      function updateCaption(){
        const realIndex = (currentIndex % totalCells + totalCells) % totalCells;
        const caption = $cells.eq(realIndex).find('.carousel-caption').text();
        const pageNumber = `${realIndex + 1}/${totalCells} `;
        $captionOutput.html('<span class="_h5">'+pageNumber+'</span>'+caption);
        updateActiveCell();
      }

      function updateActiveCell(){
        const realIndex = (currentIndex % totalCells + totalCells) % totalCells;
        $carousel.find('.carousel-cell').removeClass('active');
        $cells.eq(realIndex).addClass('active');
      }

      function freezePosition(){

        const style = window.getComputedStyle($carousel[0]);
        const matrix = style.transform;

        let currentX = -currentIndex * cellWidth;

        if(matrix && matrix !== 'none'){
          const values = matrix.match(/matrix.*\((.+)\)/)[1].split(',');
          currentX = parseFloat(values[4]);
        }

        $carousel.css({
          transition:'none',
          transform:`translateX(${currentX}px)`
        });

        $carousel[0].offsetHeight;
        return currentX;
      }

      function goToSlide(targetIndex){

        if(isAnimating) return;
        isAnimating = true;

        const currentTransform = freezePosition();
        const distance = -targetIndex * cellWidth;
        const diff = distance - currentTransform;
        const duration = 300;

        let start = null;

        function animateSlide(timestamp){

          if(!start) start = timestamp;

          const progress = Math.min((timestamp-start)/duration,1);
          const eased = 1 - Math.pow(1-progress,3);
          const pos = currentTransform + diff * eased;

          $carousel.css('transform',`translateX(${pos}px)`);

          if(progress < 1){

            animFrame = requestAnimationFrame(animateSlide);

          }else{

            currentIndex = targetIndex;

            if(currentIndex >= totalCells*2) currentIndex = totalCells;
            if(currentIndex < totalCells) currentIndex = totalCells*2-1;

            $carousel.css('transition','none');
            $carousel.css('transform',`translateX(${-currentIndex*cellWidth}px)`);

            updateCaption();
            isAnimating = false;
          }
        }

        animFrame = requestAnimationFrame(animateSlide);
      }

      $nextBtn.on('click',function(){
        goToSlide(currentIndex+1);
      });

      $prevBtn.on('click',function(){
        goToSlide(currentIndex-1);
      });

      $carousel.on('mousedown touchstart',function(e){
        e.preventDefault();
        if(e.type==='mousedown' && e.button!==0) return;
        if(isAnimating) return;

        isDragging = true;
        $carousel.css('transition','none');

        startX = e.type==='touchstart'
          ? e.originalEvent.touches[0].clientX
          : e.clientX;

        lastX = startX;
        lastTime = Date.now();

        cancelAnimationFrame(animFrame);
      });

      $(document).on('mousemove.gallery touchmove.gallery',function(e){

        if(!isDragging) return;

        const x = e.type==='touchmove'
          ? e.originalEvent.touches[0].clientX
          : e.clientX;

        const now = Date.now();
        const delta = x-lastX;

        velocity = delta/(now-lastTime);

        lastX = x;
        lastTime = now;

        dragDelta = (x-startX);

        const offset = -currentIndex*cellWidth + dragDelta;
        $carousel.css('transform',`translateX(${offset}px)`);
      });

      $(document).on('mouseup.gallery touchend.gallery',function(){

        if(!isDragging) return;

        isDragging = false;

        const momentum = velocity*250;
        const totalMove = dragDelta + momentum;

        let targetIndex = currentIndex;

        if(totalMove < -70) targetIndex++;
        else if(totalMove > 70) targetIndex--;

        goToSlide(targetIndex);

        dragDelta = 0;
        velocity = 0;
      });

      $(window).on('resize',function(){

        cellWidth = $carousel.children('.carousel-cell').outerWidth(true);

        $carousel.css('transition','none');
        $carousel.css('transform',`translateX(${-currentIndex*cellWidth}px)`);

      });

      $carousel.css('transform',`translateX(${-currentIndex*cellWidth}px)`);

      updateCaption();

      ////////////////////////////////////////////////////////////////
      // Custom Cursor
      ////////////////////////////////////////////////////////////////

      const $cursor = $wrapper.find('.custom-carousel-cursor');

      let mouseX=0, mouseY=0;
      let cursorX=0, cursorY=0;

      $wrapper.on('mousemove touchmove',function(e){

        const x = e.type==='touchmove'
          ? e.originalEvent.touches[0].clientX
          : e.clientX;

        const y = e.type==='touchmove'
          ? e.originalEvent.touches[0].clientY
          : e.clientY;

        mouseX = x;
        mouseY = y;

      });

      $(document).on('mousemove.galleryCursor',function(e){

        mouseX = e.clientX;
        mouseY = e.clientY;

        if($wrapper.length){

          if(isMouseInsideViewport()){
            $cursor.css("opacity","1");
          }else{
            $cursor.css("opacity","0");
          }

        }

      });

      function animateCursor(){

        cursorX += (mouseX-cursorX)*0.2;
        cursorY += (mouseY-cursorY)*0.2;

        $cursor.css(
          'transform',
          `translate(${cursorX}px,${cursorY}px) translate(-50%,-50%)`
        );

        requestAnimationFrame(animateCursor);
      }

      $viewport.on('mouseleave',function(){
        $cursor.css('opacity','0');
      });

      $viewport.on('mouseenter',function(){
        $cursor.css('opacity','1');
      });

      function isMouseInsideViewport(){

        const wrapperRect = $wrapper[0].getBoundingClientRect();

        return (
          mouseX >= wrapperRect.left &&
          mouseX <= wrapperRect.right &&
          mouseY >= wrapperRect.top &&
          mouseY <= wrapperRect.bottom
        );

      }

      animateCursor();

    });

  });


  /////////////////////////////////////////////////////////////////////
  // SIDE MENU JS POSITIONED FIXED.  
  /////////////////////////////////////////////////////////////////////
  function updateSideMenuPosition() {
    $('.bry-side-menu').css({'top': $(window).scrollTop() + 'px'});
  }
  $(window).on('load', updateSideMenuPosition);
  $(window).on('scroll resize', updateSideMenuPosition);


  
  ////////////////////////////////////////////////////////////////
  // QUICK LINKS
  ////////////////////////////////////////////////////////////////
  jQuery(document).on('mouseenter mouseleave', '.js-flexi-quicklinks-row-text .marquee .flexi-quicklinks-row-link', function(e) {
    if (window.innerWidth > 992) {
        const obj = jQuery(this);
        const id = obj.attr('data-id');
        const img = obj.closest('.flexi-quicklinks-row-text').find('.flexi-quicklinks-row-image-' + id);

        jQuery('.flexi-quicklinks-row-image').removeClass('active');
        img.css('position', 'absolute');

        // Store timeout on the image element
        if (!img.data('timeoutId')) img.data('timeoutId', null);

        if (e.type === 'mouseenter') {
            const parent = obj.closest('.js-flexi-quicklinks-row-text');
            const parentLeft = parent.offset().left;
            const mouseX = e.pageX - parentLeft;
            const viewportWidth = jQuery(window).width();
            const imageWidth = img.outerWidth();
            const offset = 20; // spacing from cursor

            // Horizontal position
            let leftPos = ((mouseX + imageWidth + offset) > viewportWidth) 
                ? mouseX - imageWidth - offset 
                : mouseX + offset;
            
            img.css({ left: leftPos + 'px' });

            // Clear any previous timeout
            if (img.data('timeoutId')) clearTimeout(img.data('timeoutId'));

            const timeoutId = setTimeout(function(){
              img.addClass('active');
              img.data('timeoutId', null);
            }, 250);

            img.data('timeoutId', timeoutId);

        } else if (e.type === 'mouseleave') {
            // Clear timeout if still pending
            if (img.data('timeoutId')) {
                clearTimeout(img.data('timeoutId'));
                img.data('timeoutId', null);
            }
            img.removeClass('active');
        }
    }
  });


  
  ////////////////////////////////////////////////////////////////
  // Normalize ticker speed
  ////////////////////////////////////////////////////////////////
  
  // feat project
  $('.js-flexi-quicklinks-row-text .marquee').each(function() {
    var $this = $(this);
    var contentWidth = $this.get(0).scrollWidth; // total scrollable width
    var duration = contentWidth / 120; // 120 is the speed
    $this.css({ 'animation-duration': duration + 's' });
  });

  // project archive
  $('.flexi-featured-project-col-ticker-tape').each(function() {
    var $this = $(this);
    var contentWidth = $this.get(0).scrollWidth; // total scrollable width
    var duration = contentWidth / 200; // 200 is the speed
    $this.css({ 'animation-duration': duration + 's' });
  });


  
  ////////////////////////////////////////////////////////////////
  // Partners Logo - init flickity slider
  ////////////////////////////////////////////////////////////////
  if ($('.js-flickity-partners-block').length) {

    const $partners_slider = $('.js-flickity-partners-block');
    let flktyInstance = null;

    function initCrossfadeSlider() {
      const $viewport_width = window.innerWidth;
      const visibleColumns = ($viewport_width < 768)? 1: 5;
      // destroy existing instance if present
      if (flktyInstance) { $partners_slider.flickity('destroy'); }
      const slideCount = $partners_slider.find('.js-flickity-partners-block-cell').length;
      const isMobile = $viewport_width < 768;
      // initialize Flickity
      $partners_slider.flickity({
        cellSelector: '.js-flickity-partners-block-cell',
        cellAlign: isMobile ? 'center' : 'left',
        contain: true,
        groupCells: false,
        wrapAround: slideCount > visibleColumns,
        pageDots: false,
        prevNextButtons: false,
        draggable: slideCount > visibleColumns,
        autoPlay: 2000,
        pauseAutoPlayOnHover: true,
        //freeScroll: true,
      });
      flktyInstance = $partners_slider.data('flickity');

      if (flktyInstance) {
        flktyInstance.on('dragEnd', function () {
          flktyInstance.playPlayer();
        });

        flktyInstance.on('settle', function () {
          flktyInstance.playPlayer();
        });
      }
    }
    //if(window.innerWidth < 768){
      initCrossfadeSlider();
    //}

    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          initCrossfadeSlider();
        }, 250);
    });
    
    // Custom controls
    $('.js-flexi-crossfade-prev').on('click', function () {
      if (flktyInstance) flktyInstance.previous();
    });

    $('.js-flexi-crossfade-next').on('click', function () {
      if (flktyInstance) flktyInstance.next();
    });
  }


  ////////////////////////////////////////////////////////////////
  // TABBED DYNAMIC CONTENT
  ////////////////////////////////////////////////////////////////
  $('.tabbed-dynamic-content__tab').on('click', function () {
    const index = $(this).data('tab');

    // Update active tab
    $(this)
      .addClass('is-active')
      .siblings()
      .removeClass('is-active');

    // Update text content
    const $content = $(this)
      .closest('.tabbed-dynamic-content__left')
      .find('.tabbed-dynamic-content__text');
    $content.removeClass('is-active');
    $content.filter('[data-content="' + index + '"]').addClass('is-active');

    // Update image with fade
    const $images = $(this)
      .closest('.tabbed-dynamic-content')
      .find('.tabbed-dynamic-content__image');
    $images.removeClass('is-active');
    $images.filter('[data-image="' + index + '"]').addClass('is-active');
  });




  ////////////////////////////////////////////////////////////////
  // SBI Instagram Feed Carousel
  ////////////////////////////////////////////////////////////////
  $('.section-flexi-instagram-carousel .custom-carousel-wrapper').each(function(){
    const $wrapper = $(this);

    const waitForSbi = setInterval(() => {
      const $carousel = $wrapper.find('#sbi_images');
      const $items = $carousel.children('.sbi_item').not('.sbi_num_diff_hide');

      if ($items.length > 0) {
        clearInterval(waitForSbi);
        initSbiCarousel($wrapper);
      }
    }, 200);
  });
  






}); //document.ready


